// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"ae2ccecd","521":"adcd2f7f"}[chunkId] + ".css";
};